import { log } from "../utils/log_utils";
import apiClient from "../utils/api_client";


async function getResumeAnalytics(resumeFile, resumeText, role){
    try {
      const formData = new FormData();
      formData.append("resume", resumeFile);
      formData.append("resumeText", resumeText);
      formData.append("role", role);
      
      const requestOptions = {
        'method': "POST",
        'body': formData,
        'redirect': "follow",
        'credentials': 'include',
        headers: {}
      };

      const response = await apiClient( '/analyse', requestOptions);
      const { success, resp } = response;
      log("",{success, resp},'getResumeAnalytics');
      return { success, resp }
    } catch (error) {
      log("error getting resume analytics",error,'getResumeAnalytics');
      return { success: false, resp: error }
    }
  };


  async function getUserResumes() {
    try {
      return await apiClient( '/user/resumes',{
        method: 'GET',
        credentials: "include"
      })
    } catch (error) {
      log("error getting user resumes",error,'getUserResumes');
      return { success: false, resp: error?.message || error }
    }

  }

  async function deleteResume(resumeId){
    try {
      return await apiClient( '/resumes/delete',{
        method: 'DELETE',
        credentials: "include",
        body: JSON.stringify({
          resumeId
        })
      })
    } catch (error) {
      log("error deleting resume",error,'deleteResume');
      return { success: false, resp: error?.message || error }
    }
  }


  async function generateResumeShareLink(resumeId, shareConfig) {

    try {
      return await apiClient( '/resume/generate-link',{
        method: 'POST',
        credentials: "include",
        body: JSON.stringify({
          resumeId,
          shareConfig
        })
      })
    } catch (error) {
      log("error generating sharing link", error, "generateResumeShareLink")
    }
    
  }


  async function getSharedResume(token) {
    
    try {

      return await apiClient( `/resume/shared?token=${token}`,{
        method: 'GET',
        "credentials": "include"
      })
    } catch (error) {
      log("error generating sharing link", error, "generateResumeShareLink")
    }
    
  }
  
  
  async function getResumeDetail(resumeId){
    try {
      return await apiClient( `/user/resume/details`,{
        method: 'POST',
        "credentials": "include",
        body: JSON.stringify({
          resumeId
        })
      })
    } catch (error) {
      log("error generating sharing link", error, "generateResumeShareLink")
    }
  }
  

  async function getResumeComments(resumeId){
    try {
      return await apiClient( `/user/resume/comments`,{
        method: 'POST',
        "credentials": "include",
        body: JSON.stringify({
          resumeId
        })
      })
    } catch (error) {
      log("error generating sharing link", error, "generateResumeShareLink")
    }
  }

  async function getResumeJsonData(resumeId){
    try {
      return await apiClient( `/user/resume`,{
        method: 'POST',
        "credentials": "include",
        body: JSON.stringify({
          resumeId
        })
      })
    } catch (error) {
      log("error getting resume json data", error, "getResumeJsonData")
      return { success: false, resp: error?.message || error }
    }
  }

  async function updateResumeSection(resumeId, sectionType, items) {
    try {
      return await apiClient( `/user/resume/section`,{
        method: 'POST',
        "credentials": "include",
        body: JSON.stringify({
          resumeId: parseInt(resumeId),
          sectionType,
          items
        })
      })
    } catch (error) {
      log("error updating resume section", error, "updateResumeSection")
      return { success: false, resp: error?.message || error }
    }
  }

  async function saveSectionOrder(resumeId, order) {
    try {
      return await apiClient('/user/resume/section-order', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          resumeId: parseInt(resumeId),
          order
        })
      });
    } catch (error) {
      log("error saving section order", error, "saveSectionOrder");
      return { success: false, resp: error?.message || error };
    }
  }

  async function startResumeGeneration(resumeId, jdText, companyName) {
    try {
      return await apiClient('/user/resume/resume-generations', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          resume_id: parseInt(resumeId, 10),
          jd_text: jdText,
          company_name: companyName || undefined
        })
      });
    } catch (error) {
      log("error starting resume generation", error, "startResumeGeneration");
      return { success: false, resp: error?.message || error };
    }
  }

  export { getResumeAnalytics,
           getUserResumes,
           deleteResume,
           generateResumeShareLink,
           getSharedResume,
           getResumeDetail,
           getResumeComments,
           getResumeJsonData,
           updateResumeSection,
           saveSectionOrder,
           startResumeGeneration
          }